<template>
  <div v-if="acessoPermitido" class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Consultar Holerite</h4>
          <div>
            <!-- Filtros -->
            <div
              class="w-full max-w-lg flex flex-wrap gap-2 justify-center mb-4"
            >
              <select v-model="mes" class="p-2 border rounded w-full sm:w-auto">
                <option
                  v-for="(nome, index) in meses"
                  :key="index"
                  :value="index + 1"
                >
                  {{ nome }}
                </option>
              </select>

              <select v-model="ano" class="p-2 border rounded w-full sm:w-auto">
                <option
                  v-for="anoOp in anosDisponiveis"
                  :key="anoOp"
                  :value="anoOp"
                >
                  {{ anoOp }}
                </option>
              </select>

              <base-button
                type="success"
                @click="buscarHolerite"
                class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition w-full sm:w-auto"
              >
                Buscar
              </base-button>
            </div>

            <!-- Seleção de Holerite (se houver múltiplos) -->
            <div v-if="listaHolerites.length > 1" class="mb-4">
              <label class="block text-gray-700 font-bold mb-2"
                >Múltiplos holerites encontrados. Selecione um:</label
              >
              <div class="flex flex-wrap gap-2">
                <base-button
                  v-for="h in listaHolerites"
                  :key="h.id"
                  :type="
                    holeriteSelecionado && holeriteSelecionado.id === h.id
                      ? 'info'
                      : 'success'
                  "
                  @click="selecionarHolerite(h)"
                  class="btn-sm"
                >
                  {{ h.tipo_holerite || "Mensal" }} ({{
                    formatDate(h.data_insercao)
                  }})
                </base-button>
              </div>
            </div>

            <!-- Exibição do PDF -->
            <div class="w-full flex-grow flex justify-center items-center">
              <iframe
                v-if="pdfUrl"
                :src="pdfUrl"
                class="w-full h-[60vh] border shadow-lg rounded-md"
              ></iframe>
            </div>

            <!-- Botão de Download -->
            <div class="flex flex-col sm:flex-row gap-2 mt-4">
              <base-button
                v-if="pdfUrl"
                @click="baixarPDF"
                type="success"
                class="success"
              >
                Baixar PDF
              </base-button>
              <base-button
                v-if="pdfUrl"
                @click="signPayslip"
                type="success"
                class="success"
              >
                Assinar Holerite
              </base-button>
              <base-button
                v-if="pdfUrl"
                @click="baixarPDFAssinado"
                type="success"
                class="success"
              >
                Visualizar PDF Assinado
              </base-button>
            </div>

            <!-- Modal de Aviso -->
            <div
              v-if="mostrarAviso"
              class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50"
              @click.self="fecharAviso"
            >
              <div class="bg-white p-6 rounded shadow-lg text-center max-w-md">
                <h2 class="text-xl font-semibold text-red-600">
                  Holerites não encontrado
                </h2>
                <p class="text-gray-600 mt-2">
                  Nenhum holerite foi encontrado para o mês de
                  {{ meses[mes - 1] }}.
                </p>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
  <div v-else-if="!acessoPermitido && !pageErro" class="content small">
    <modal v-if="showRecFacial" :show.sync="showRecFacial">
      <modal-rec-facial-2 width="80%" height="80%" />
    </modal>
  </div>
  <div v-else-if="pageErro" class="content small">
    <div class="flex flex-col items-center justify-center h-full">
      <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
        Acesso Negado
      </h1>
      <p class="text-gray-600 text-center">
        Você não tem permissão para acessar esta página.
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ModalRecFacial2 from "../../src/pages/Components/ModalRecFacial2.vue";
import swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import { Card } from "@/components/index";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    ModalRecFacial2,
    Loading,
    Card,
    Modal,
  },
  data() {
    return {
      mes: new Date().getMonth() + 1, // Mês atual
      ano: new Date().getFullYear(), // Ano atual
      mostrarAviso: false,
      isLoading: false,
      showRecFacial: true,
      acessoPermitido: false,
      pageErro: false,
      pdfUrl: "",
      listaHolerites: [],
      holeriteSelecionado: null,
      meses: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
      anosDisponiveis: [2023, 2024, 2025, 2026], // Ajuste conforme necessário
    };
  },
  mounted() {
    this.carregarDados();

    this.$root.$on("checkFacial", (data) => {
      try {
        if (data) {
          this.showRecFacial = false;
          this.acessoPermitido = true;
          this.pageErro = false; // Garante que a tela de erro não apareça
        } else {
          this.showRecFacial = false; // Fecha a modal de reconhecimento facial
          this.acessoPermitido = false; // Bloqueia o acesso
          this.pageErro = true; // Mostra a tela de acesso negado
        }
      } catch {
        this.showRecFacial = false;
        this.acessoPermitido = false;
        this.pageErro = true;
      }
    });
  },
  methods: {
    async carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        swal({
          title: title,
          text: text,
          icon: typeMsg,
          showConfirmButton: true,
        });
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("pt-BR");
    },
    selecionarHolerite(h) {
      this.holeriteSelecionado = h;
      this.exibirPDF(h);
    },
    async buscarHolerite() {
      try {
        this.isLoading = true;
        this.pdfUrl = "";
        this.holeriteSelecionado = null;
        this.listaHolerites = [];

        const form = {
          month: `${this.ano}-${this.mes.toString().padStart(2, "0")}`,
          funcionario: this.dados.ID_EMPREGADO, // Assumindo que temos ID_EMPREGADO nos dados da sessão
          setDB: this.dados.DB_NAME,
          relatorio: false,
          isFuncionario: true,
        };

        // Primeiro busca a lista para ver se tem múltiplos
        const response = await axios.post(`/api/holerites`, form, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        });
        this.listaHolerites = response.data.filter((h) => h.liberacao === 1);

        if (this.listaHolerites.length === 0) {
          this.mostrarAviso = true;
        } else if (this.listaHolerites.length === 1) {
          this.holeriteSelecionado = this.listaHolerites[0];
          this.exibirPDF(this.holeriteSelecionado);
        } else {
          // Mais de um, o usuário seleciona
          this.mostrarAviso = false;
        }
      } catch (error) {
        console.error("Erro ao buscar holerite:", error);
        this.pdfUrl = "";
        this.mostrarAviso = true;
      } finally {
        this.isLoading = false;
      }
    },
    async exibirPDF(holerite) {
      try {
        this.isLoading = true;
        const form = {
          mesReferencia: `${this.ano}-${this.mes.toString().padStart(2, "0")}`,
          cpf: this.dados.CPF_EMPREGADO,
          setDB: this.dados.DB_NAME,
          isFuncionario: 1,
          tipo_holerite: holerite.tipo_holerite,
        };

        const response = await axios.post(`/api/listaHoleritePorCPF`, form, {
          responseType: "blob",
        });

        if (response.data.size === 0) {
          this.pdfUrl = "";
          this.mostrarAviso = true;
        } else {
          this.pdfUrl = URL.createObjectURL(response.data);
          this.mostrarAviso = false;
        }
      } catch (error) {
        console.error("Erro ao carregar PDF:", error);
      } finally {
        this.isLoading = false;
      }
    },
    baixarPDF() {
      if (this.pdfUrl) {
        const a = document.createElement("a");
        a.href = this.pdfUrl;
        a.download = "holerite.pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    async baixarPDFAssinado() {
      this.isLoading = true;
      try {
        const response = await axios.post(
          "/api/listaHoleritePorCPFAssinado",
          {
            isVisualizacao: 1,
            setDB: this.dados.DB_NAME,
            cpf: this.dados.CPF_EMPREGADO,
            mesReferencia: `${this.ano}-${String(this.mes).padStart(2, "0")}`,
            tipo_holerite: this.holeriteSelecionado
              ? this.holeriteSelecionado.tipo_holerite
              : null,
          },
          { responseType: "blob" },
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        const pdfUrl = window.URL.createObjectURL(blob);
        window.open(pdfUrl, "_blank");
      } catch (error) {
        if (error) {
          this.showSwal(
            "Aviso",
            "Aviso",
            "É necessário assinar o holerite antes.",
            "warning",
          );
        }
      } finally {
        this.isLoading = false;
      }
    },
    async signPayslip() {
      try {
        this.isLoading = true;
        const ipResponse = await axios.get(
          "https://api64.ipify.org?format=json",
        );
        const ipUsuario = ipResponse.data.ip;
        const form = {
          mesReferencia: `${this.ano}-${this.mes.toString().padStart(2, "0")}`, // Garantindo dois dígitos para o mês
          cpf: this.dados.CPF_EMPREGADO,
          setDB: this.dados.DB_NAME,
          nome: this.dados.NOME_EMPREGADO,
          ip: ipUsuario,
          tipo_holerite: this.holeriteSelecionado
            ? this.holeriteSelecionado.tipo_holerite
            : "Mensal",
        };

        const response = await axios.post("/api/assinarHolerite", form, {
          responseType: "blob",
        });

        if (response.data.size > 0) {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);

          // Atualiza a exibição com o PDF assinado
          this.pdfUrl = url;
          this.showSwal(
            "auto-close",
            "Sucesso",
            `${this.dados.NOME_EMPREGADO}, seu holerite foi assinado com sucesso!`,
            "success",
          );
        } else {
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao assinar o holerite. Tente novamente mais tarde.",
            "error",
          );
        }
      } catch (error) {
        console.error("Erro ao assinar holerite:", error);
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao assinar o holerite. Tente novamente mais tarde.",
          "error",
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
